import { FC } from 'react';
import { Box, Center, Flex } from 'styled-system/jsx';
import { useNavigate } from 'react-router-dom';
import Typography from '@/common/components/base/typography/Typography.tsx';
import CloseIcon from '@/common/assets/icons/closeIcon.svg?react';
import { token } from 'styled-system/tokens';

type Props = { title: string };

const CloseHeader: FC<Props> = ({ title }) => {
  const navigate = useNavigate();
  const handleCloseTrigger = () => {
    navigate(-1);
  };
  return (
    <Flex
      maxW="maxContainer"
      mx="auto"
      bgColor="white"
      shadow="headerShadow"
      height="66px"
      alignItems="center"
    >
      <Center onClick={handleCloseTrigger} w="15%">
        <CloseIcon stroke={token('colors.black-3')} />
      </Center>
      <Box w={'80%'}>
        <Typography textAlign="center" color="black-1">
          {title}
        </Typography>
      </Box>
      <Box w={'15%'} />
    </Flex>
  );
};

export default CloseHeader;
